export default {"src":"/_next/static/media/registry-settings-windows.9fd79d8b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};